"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reviverDependencies = void 0;
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var reviverDependencies = exports.reviverDependencies = {
  createReviver: _factoriesAny.createReviver
};